var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"ma-2",attrs:{"color":_vm.item.active ? `green` : `red`,"label":"","outlined":"","small":""}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v(_vm._s(_vm.item.active ? `mdi-check-circle` : `mdi-circle-off-outline`))]),_vm._v(" "+_vm._s(_vm.item.active ? `Ativo` : `Inativo`)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }